import { LevelData } from '../level-data';

export const level15: LevelData = {
    name: 'Rhythm',
    timeLimit: 105,
    track: [
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '---  --',
        '-------',
        '---B---',
        '-------',
        '--  ---',
        '-------',
        '---B---',
        '-------',
        '---  --',
        '-------',
        '---S---',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '--  ---',
        '-------',
        '---B---',
        '-------',
        '---  --',
        '-------',
        '---B---',
        '-------',
        '--  ---',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
